import { Box, Typography } from '@mui/material';
import { currency } from './building_blocks/Currency';

const ProductPriceSimulation = ({ product }) => {
  const bankFee = (3.99 / 100 * product.price) + 39; // 39 já é cents
  const appFee = 5 / 100 * product.price;
  const totalFee = bankFee + appFee;
  const netValue = product.price - totalFee;

  return (
    <Box mt={2}>
      <Typography textAlign="left" variant="body2"><b>Taxas</b></Typography>
      <Typography mt={1} textAlign="left" variant="body2">
        Taxa do banco: <strong>{currency(bankFee)}</strong> (3,99% + R$0,39/Tr.)</Typography>
      <Typography textAlign="left" variant="body2">
        Taxa do app: <strong>{currency(appFee)}</strong> (5%)
      </Typography>
      
      <Typography mt={2} textAlign="left" variant="body2">
        Valor Líquido por Venda Aprox.: ~<strong>{currency(netValue)}</strong>
      </Typography>
    </Box>
  );
};

export default ProductPriceSimulation;